export default "__VITE_ASSET__CutfOTGL__"